import styled from 'styled-components';
import { colors } from "colors";
export { InfoWrapper } from "components";

export const ColumnWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
`;

export const Column = styled.div`
  flex: 1;
  padding: 8px;
  
  display: flex;
  flex-direction: column;
  min-width: 450px;
`;


export const CardFormHeading = styled.p`
  font-size: 14px;
  color: ${colors.slateGrey};
  font-weight: bold;
`;

export const CardForm = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 32px;

  display: flex;
  flex-direction: column;
  
  font-size: 14px;
  color: ${colors.slateGrey};
  
  input,
  textarea, 
  select, 
  .select-box,
  .file-input {
    margin-bottom: 16px;
  }

  label {
    margin-bottom: 4px;
  }
`;


export const ButtonWrapper = styled.button`
  flex: 1;
  border: 0;
  padding: 24px;
  margin-top: 32px;
  border-radius: 4px;
  background-color: ${colors.brightBlue};
  box-shadow: 2px 2px 4px ${colors.silver};
  
  color: ${colors.white};
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  
  :hover {
    box-shadow: 4px 4px 8px ${colors.silver};
    cursor: pointer;
  }
  
  &[data-loading="true"] {
    cursor: progress;
    background-color: ${colors.alabaster};
  }
`;

export const Disclaimer = styled.p`
  font-size: 14px;
  color: ${colors.slateGrey};
  align-self: center;
`;
